module.exports = __webpack_public_path__ + "img/图1-2  数据相关术语.87fa5d0a.png";